import React, { useEffect, useState } from 'react';
import { Route, Routes as ReactRoutes, Navigate } from "react-router-dom";
// --- Import all your components ---
import Dashboard from './Dashboard/Dashboard';
import PoojaDashboard from './Pooja/PoojaDashboard';
import PoojaCounts from './Pooja/PoojaCounts';
import Header from '../components/common/Header';
import ScrollToTop from '../components/common/ScrollToTop';
import CouponsList from './Coupons/CouponsList';
import CouponsAdd from './Coupons/CouponsAdd';
import CouponsEdit from './Coupons/CouponsEdit';
import TeamStaffList from './Users/UsersList';
import TeamStaffAdd from './Users/UsersAdd';
import AddFAQ from './FAQ/AddFAQ';
import FAQList from './FAQ/FAQList';
import ExpertiseAdd from './Expertise/ExpertiseAdd';
import ExpertiseEdit from './Expertise/ExpertiseEdit';
import ExpertiseList from './Expertise/ExpertiseList';
import HeatMapBox from './HeatMap/HeatMapBox';
import { PrivacyPolicy } from './PrivacyPolicy/PrivacyPolicy';
import AstrologerList from './Astrologer/AstrologerList';
import AstrologerAdd from './Astrologer/AstrologerAdd';
import AstoReqView from './Astrologer/AstoReqView';
import AstrologerView from './Astrologer/AstrologerView';
import AstrolgerBooking from './Astrologer/AstrolgerBooking';
import OnlineStatus from './Astrologer/OnlineStatus';
import ManageServiceToggles from './Astrologer/ManageServiceToggles';
import AIAstrologerList from './AIAstrologer/AIAstrologerList';
import AIAstrologerAdd from '../components/AIAstrologer/AIAstrologerAdd';
import AIAstrologerView from './AIAstrologer/AIAstrologerView';
import AstroProfilePopup from './AstroProfilePopup/AstroProfilePopup';
import BookingAdd from './Booking/BookingAdd';
import BookingDetails from './Booking/BookingDetails';
import BookingEdit from './Booking/BookingEdit';
import BookingList from './Booking/BookingList';
import ChatHistory from './Booking/ChatHistory';
import LanguageAdd from './Language/LanguageAdd';
import LanguageList from './Language/LanguageList';
import { TermsAndCondition } from './TermsAndConditions/TermsAndCondition';
import { AboutUs } from './AboutUs/AboutUsScreens';
import RefundPolicy from './RefundPolicy/RefundPolicy';
import SupportQuery from './Support/SupportQuery';
import SupportQueryView from './Support/SupportQueryView';
import EductionCouponList from './EductionCoupon/EductionCouponList';
import EducationCouponAdd from './EductionCoupon/EducationCouponAdd';
import ListGooglePayCoupon from './GooglePayCoupon/ListGooglePayCoupon';
import AddGooglePayCoupon from './GooglePayCoupon/AddGooglePayCoupon';
import ViewGoogleCopon from './GooglePayCoupon/ViewGoogleCopon';
import ListOffer from './OfferModules/Listoffer';
import AddOffer from './OfferModules/AddOffer';
import ListGeneric from './GenericFaq/ListGeneric';
import AddReferEarnFAQs from './ReferEarnFAQs/AddReferEarnFAQs';
import ListReferEarnFAQs from './ReferEarnFAQs/ListReferEarnFAQs';
import AddGeneric from './GenericFaq/AddGeneric';
import ListReview from './GenericReview/ListReview';
import AddReview from './GenericReview/AddReview';
import ListConsultationCoupon from './ConsultationCoupon/ListConsultationCoupon';
import AddConsultationCoupon from './ConsultationCoupon/AddConsultationCoupon';
import UserFeedbackList from './UserFeedBack/userfeedbackList';
import AstrologerSupportList from './AstrologerSupport/AstrologerSupportList';
import AstroSupportDetails from './AstrologerSupportDetails/AstroSupportDetails';
import AstroSupportView from './AstrologerSupportDetails/AstroSupportView';
import ConsultationList from './ConsultationVoucher/ConsultationList';
import ConsultationAdd from './ConsultationVoucher/ConsultationAdd';
import CampaignConsultationList from './Campaign/CampaignList';
import CampaignConsultationAdd from './Campaign/CampaignAdd';
import WalletTagesList from './WalletTages/WalletTagesList';
import WalletTagesAdd from './WalletTages/WalletTagesAdd';
import Notification from './Notification/Notification';
import AstroSupportChat from './AstrologerSupport/AstroSupportChat';
import UserMessageView from './UserFeedBack/UserMessageView';
import FeedbackCallbackList from './CallbackRequests/FeedbackCallbackList';
import DailyRechargeReport from './Reports/DailyRechargeReports';
import InvoiceReportList from './Reports/InVoiceReports';
import SessionReports from './Reports/SessionReport';
import SummaryReports from './Reports/SummaryReports';
import CouponUsesReport from './Reports/CouponUsesReport';
import CreditReports from './Reports/CreditReports';
import PayoutReports from './Reports/PayoutReports';
import PayoutReportView from './Reports/PayoutReportView';
import WalletBalanceReport from './Reports/WalletBalanceReport';
import WalletBonusReport from './Reports/WalletBonusReport';
import AstrologerStatusByTimeRange from './Reports/AstrologerStatusByTimeRange';
import UserBookings from './Users/UserBookings';
import AstroList from './AstroTag/AstroList';
import AstroTag from './AstroTag/AstroTag';
import UserSupportList from './UserSupport/UserSupportList';
import UserSupportChat from './UserSupport/UserSupportChat';
import UserRole from './RoleAndUser/User/UserRole';
import AddRole from './RoleAndUser/Role/AddRole';
import RoleAndUserManagment from './RoleAndUser/Role/RoleAndUserManagment';
import AddUserrole from './RoleAndUser/User/AddUserrole';
import TopBanner from './BannerManagment/TopBanner/TopBanner';
import ConsultationType from './BannerManagment/ConsultationType/ConsultationType';
import ServicesType from './BannerManagment/ServicesType/ServicesType';
import ForceUpdate from './ForceUpdate/forceUpdate';
import DefaultRedirection from './DefaultRedirection/DefaultRedirection';
import OnboardingImages from './BannerManagment/OnboardingImages/OnboardingImages';
import PromoBanner from './BannerManagment/PromoBanner/PromoBanner';
import PoojaCategoryRedirection from './Pooja/PoojaCategoryRedirection';
import HomeNavIcons from './HomeNavIcons/HomeNavIcons';
import HamburgerMenu from './HamburgerMenu/HamburgerMenu';
import AstrologyServices from './CMS/AstrologyServices/AstrologyServices';
import Horoscope from './CMS/Horoscope/Horoscope';
import TrendingConsultations from './CMS/TrendingConsultations/TrendingConsultations';
import AdvertisementBanner from './CMS/AdvertisementBanner/AdvertisementBanner';
import RecommendedFreeChat from './CMS/RecommendedFreeChat/RecommendedFreeChat';
import VideoList from './Videos/VideoList';
import VideoAdd from './Videos/VideoAdd';
import ReferralReport from './Reports/ReferralReport';
import ReferralAmounts from './CMS/ReferralAmounts/ReferralAmounts';
import UsersListReadOnly from './User List/UsersList';
import IssueCreditNote from './IssueCreditNote/IssueCreditNote';
import ReferralScreenConfig from './CMS/ReferralScreenConfig/ReferralScreenConfig';
import AstroEarningHistory from './Reports/AstroEarningHistory';
import CouponText from './CMS/CouponText/CouponText';
import CashBackList from './CashBack/CashBackList';
import CashBackAdd from './CashBack/CashBackAdd';
import CashbackReportExport from './Reports/CashbackReportExport';
import FreeChatReports from './Reports/FreeChatReports';
import RecordingRetention from './RecordingRetention/RecordingRetention';
import PoojaList from './Pooja/PoojaList';
import PoojaMapping from './Pooja/PoojaMapping';
import CategoryList from './Pooja/CategoryList';
import HookMessageConfig from './HookMessageConfig/HookMessageConfig';
import PoojaReviews from './Pooja/PoojaReviews';
import PoojaConfig from './Pooja/PoojaConfig';
import AstroRemedy from './Pooja/AstroRemedy';
import AstrologerReassign from './Pooja/AstrologerReassign';
import PoojaTransactionReport from './Reports/PoojaTransactionReport';
import PoojaReport from './Reports/PoojaReport';
import PoojaRecommendationReport from './Reports/PoojaRecommendationReport';
import WalletDeductionConfig from './WalletConfig/WalletDeductionConfig';
import BonusExpiryConfig from './WalletConfig/BonusExpiryConfig';
import PoojaSharingConfig from './WalletConfig/PoojaSharingConfig';
import FreeChatRouting from './CMS/FreeChatRouting/FreeChatRouting';
import TicketSubjectList from './CMS/TicketSubjectList';
import ShowDeleteAccountButton from './AccountManagement/ShowDeleteAccountButton';
import AdminConfig from './AccountManagement/AdminConfig';
import PoojaImageVerification from './Pooja/PoojaImageVerification';
import PoojaBookings from './Pooja/PoojaBookings';
import PoojaTagList from './Pooja/PoojaTagList';
import LoyaltyOfferList from './Monetization/BucketManagement/LoyaltyOfferList';
import AddLoyaltyOffer from './Monetization/BucketManagement/AddLoyaltyOffer';
import RedisExpire from './RedisExpire/RedisExpire';
import FreeChatAstrologersList from './CMS/FreeChatAstrologers/FreeChatAstrologersList';
import ValidateAbusiveWords from './CMS/ValidateAbusiveWords/ValidateAbusiveWords';
// =========================================================================
// THE FIX: Add a `category` property to every route and export `allRoutes`
// The `category` should match the keys in your `privilegeLabelMap`
// =========================================================================
export const allRoutes = [
    // === Dashboard ===
    { path: "/dashboard", Component: Dashboard, requiredPrivilege: "/dashboard", category: "/dashboard" },
    { path: "/pooja-dashboard", Component: PoojaDashboard, requiredPrivilege: "/pooja-dashboard", category: "/pooja-dashboard" },

    // === App Management ===
    { path: '/force-update', Component: ForceUpdate, requiredPrivilege: '/force-update', category: '/app-management' },
    { path: '/default-redirection', Component: DefaultRedirection, requiredPrivilege: '/default-redirection', category: '/app-management' },
    { path: '/home-nav-icons', Component: HomeNavIcons, requiredPrivilege: '/home-nav-icons', category: '/app-management' },
    { path: '/hamburger-menu', Component: HamburgerMenu, requiredPrivilege: '/hamburger-menu', category: '/app-management' },

    // === Redis Cache Management ===
    { path: '/redis-expire', Component: RedisExpire, requiredPrivilege: '/redis-expire', category: '/redis-expire' },

    // === Astrologer Management ===
    { path: '/expertise-list', Component: ExpertiseList, requiredPrivilege: '/expertise-list', category: '/astrologer-management' },
    { path: '/expertise-add', Component: ExpertiseAdd, requiredPrivilege: '/expertise-add', category: '/astrologer-management' },
    { path: '/expertise-edit/:id', Component: ExpertiseAdd, requiredPrivilege: '/expertise-edit/:id', category: '/astrologer-management' },
    { path: '/astro-tag-management', Component: AstroList, requiredPrivilege: '/astro-tag-management', category: '/astrologer-management' },
    { path: '/tag-add', Component: AstroTag, requiredPrivilege: '/tag-add', category: '/astrologer-management' },
    { path: '/tag-edit/:id', Component: AstroTag, requiredPrivilege: '/tag-edit/:id', category: '/astrologer-management' },
    { path: '/astrologer-list', Component: AstrologerList, requiredPrivilege: '/astrologer-list', category: '/astrologer-management' },
    { path: '/astrologer-add', Component: AstrologerAdd, requiredPrivilege: '/astrologer-add', category: '/astrologer-management' },
    { path: '/astrologer-edit/:id', Component: AstrologerAdd, requiredPrivilege: '/astrologer-edit/:id', category: '/astrologer-management' },
    { path: '/astrologer-view/:id', Component: AstrologerView, requiredPrivilege: '/astrologer-view/:id', category: '/astrologer-management' },
    { path: '/astrologerreq-view/:id', Component: AstoReqView, requiredPrivilege: '/astrologerreq-view/:id', category: '/astrologer-management' },
    { path: '/booking-by-astro/:astoID', Component: AstrolgerBooking, requiredPrivilege: '/booking-by-astro/:astoID', category: '/astrologer-management' },
    { path: '/astrologer-online-status/:id', Component: OnlineStatus, requiredPrivilege: '/astrologer-online-status/:id', category: '/astrologer-management' },
    { path: '/astrologer-status-time-range', Component: AstrologerStatusByTimeRange, requiredPrivilege: '/astrologer-status-time-range', category: '/astrologer-management' },
    { path: '/info-card', Component: AstroProfilePopup, requiredPrivilege: '/info-card', category: '/astrologer-management' },
    { path: '/manage-service-toggles', Component: ManageServiceToggles, requiredPrivilege: '/manage-service-toggles', category: '/astrologer-management' },

    // === Astrologer Support & Operations ===
    { path: '/astro-reviews', Component: ListReview, requiredPrivilege: '/astro-reviews', category: '/astrologer-support-operations' },
    { path: '/astro-reviews-add', Component: AddReview, requiredPrivilege: '/astro-reviews-add', category: '/astrologer-support-operations' },
    { path: '/review-edit/:id', Component: AddReview, requiredPrivilege: '/review-edit/:id', category: '/astrologer-support-operations' },
    { path: '/astrologer-support', Component: AstrologerSupportList, requiredPrivilege: '/astrologer-support', category: '/astrologer-support-operations' },
    { path: '/astrologer-supporttiket', Component: AstroSupportDetails, requiredPrivilege: '/astrologer-supporttiket', category: '/astrologer-support-operations' },
    { path: '/AstroView-detail/:id', Component: AstroSupportView, requiredPrivilege: '/AstroView-detail/:id', category: '/astrologer-support-operations' },
    { path: '/AstroSupportChat/:id', Component: AstroSupportChat, requiredPrivilege: '/AstroSupportChat/:id', category: '/astrologer-support-operations' },

    // === User Support & Operations ===
    { path: '/user-list', Component: UsersListReadOnly, requiredPrivilege: '/user-list', category: '/user-support-operations' },
    { path: '/user-feedback', Component: UserFeedbackList, requiredPrivilege: '/user-feedback', category: '/user-support-operations' },
    { path: '/MessageView-detail/:id', Component: UserMessageView, requiredPrivilege: '/MessageView-detail/:id', category: '/user-support-operations' },
    { path: '/user-support', Component: UserSupportList, requiredPrivilege: '/user-support', category: '/user-support-operations' },
    { path: '/user-chat/:id', Component: UserSupportChat, requiredPrivilege: '/user-chat/:id', category: '/user-support-operations' },
    { path: '/support-query', Component: SupportQuery, requiredPrivilege: '/support-query', category: '/user-support-operations' },
    { path: '/support-query-view/:id', Component: SupportQueryView, requiredPrivilege: '/support-query-view/:id', category: '/user-support-operations' },
    { path: '/callback-requests', Component: FeedbackCallbackList, requiredPrivilege: '/callback-requests', category: '/user-support-operations' },

    // === Product Management ===
    { path: '/ai-astrologer-list', Component: AIAstrologerList, requiredPrivilege: '/ai-astrologer-list', category: '/product-management' },
    { path: '/ai-astrologer-add', Component: AIAstrologerAdd, requiredPrivilege: '/ai-astrologer-add', category: '/product-management' },
    { path: '/ai-astrologer-edit/:id', Component: AIAstrologerAdd, requiredPrivilege: '/ai-astrologer-edit/:id', category: '/product-management' },
    { path: '/ai-astrologer-view/:id', Component: AIAstrologerView, requiredPrivilege: '/ai-astrologer-view/:id', category: '/product-management' },
    { path: '/language-list', Component: LanguageList, requiredPrivilege: '/language-list', category: '/product-management' },
    { path: '/language-add', Component: LanguageAdd, requiredPrivilege: '/language-add', category: '/product-management' },
    { path: '/language-edit/:id', Component: LanguageAdd, requiredPrivilege: '/language-edit/:id', category: '/product-management' },
    { path: '/notification-list', Component: Notification, requiredPrivilege: '/notification-list', category: '/product-management' },

    // === Pooja ===
    { path: '/pooja-categories', Component: CategoryList, requiredPrivilege: '/pooja-categories', category: '/pooja' },
    { path: '/pooja-list', Component: PoojaList, requiredPrivilege: '/pooja-list', category: '/pooja' },
    { path: '/pooja-mapping', Component: PoojaMapping, requiredPrivilege: '/pooja-mapping', category: '/pooja' },
    { path: '/astrologer-reassign', Component: AstrologerReassign, requiredPrivilege: '/astrologer-reassign', category: '/pooja' },
    { path: '/pooja-reviews', Component: PoojaReviews, requiredPrivilege: '/pooja-reviews', category: '/pooja' },
    { path: '/pooja-config', Component: PoojaConfig, requiredPrivilege: '/pooja-config', category: '/pooja' },
    { path: '/astro-remedy', Component: AstroRemedy, requiredPrivilege: '/astro-remedy', category: '/pooja' },
    { path: '/pooja-image-verification', Component: PoojaImageVerification, requiredPrivilege: '/pooja-image-verification', category: '/pooja' },
    { path: '/pooja-bookings', Component: PoojaBookings, requiredPrivilege: '/pooja-bookings', category: '/pooja' },
    { path: '/pooja-tags', Component: PoojaTagList, requiredPrivilege: '/pooja-tags', category: '/pooja' },


    // === Admin ===
    { path: '/role-management', Component: RoleAndUserManagment, requiredPrivilege: '/role-management', category: '/admin' },
    { path: '/addrole', Component: AddRole, requiredPrivilege: '/addrole', category: '/admin' },
    { path: '/useree/:id', Component: AddRole, requiredPrivilege: '/useree/:id', category: '/admin' },
    { path: '/user-management', Component: UserRole, requiredPrivilege: '/user-management', category: '/admin' },
    { path: '/user-role-add', Component: AddUserrole, requiredPrivilege: '/user-role-add', category: '/admin' },
    { path: '/user-role-edit/:id', Component: AddUserrole, requiredPrivilege: '/user-role-edit/:id', category: '/admin' },

    // === CMS ===
    { path: '/free-chat-astrologers', Component: FreeChatAstrologersList, requiredPrivilege: '/free-chat-astrologers', category: '/cms' },
    { path: '/users-list', Component: TeamStaffList, requiredPrivilege: '/users-list', category: '/cms' },
    { path: '/users-add', Component: TeamStaffAdd, requiredPrivilege: '/users-add', category: '/cms' },
    { path: '/users-edit/:id', Component: TeamStaffAdd, requiredPrivilege: '/users-edit/:id', category: '/cms' },
    { path: '/booking-by-user/:userId', Component: UserBookings, requiredPrivilege: '/booking-by-user/:userId', category: '/cms' },
    { path: '/booking-list', Component: BookingList, requiredPrivilege: '/booking-list', category: '/cms' },
    { path: '/booking-add', Component: BookingAdd, requiredPrivilege: '/booking-add', category: '/cms' },
    { path: '/booking-edit/:id', Component: BookingEdit, requiredPrivilege: '/booking-edit/:id', category: '/cms' },
    { path: '/booking-details/:id', Component: BookingDetails, requiredPrivilege: '/booking-details/:id', category: '/cms' },
    { path: '/chat-history/:userId/:astroId', Component: ChatHistory, requiredPrivilege: '/chat-history/:userId/:astroId', category: '/cms' },
    { path: '/coupons-list', Component: CouponsList, requiredPrivilege: '/coupons-list', category: '/cms' },
    { path: '/coupons-add', Component: CouponsAdd, requiredPrivilege: '/coupons-add', category: '/cms' },
    { path: '/coupons-edit/:id', Component: CouponsEdit, requiredPrivilege: '/coupons-edit/:id', category: '/cms' },
    { path: '/eduction-modulecoupon', Component: EductionCouponList, requiredPrivilege: '/eduction-modulecoupon', category: '/cms' },
    { path: '/educationcoupon-add', Component: EducationCouponAdd, requiredPrivilege: '/educationcoupon-add', category: '/cms' },
    { path: '/googlepay-coupon', Component: ListGooglePayCoupon, requiredPrivilege: '/googlepay-coupon', category: '/cms' },
    { path: '/googlepaycoupon-add', Component: AddGooglePayCoupon, requiredPrivilege: '/googlepaycoupon-add', category: '/cms' },
    { path: '/google-view/:id', Component: ViewGoogleCopon, requiredPrivilege: '/google-view/:id', category: '/cms' },
    { path: '/offer-list', Component: ListOffer, requiredPrivilege: '/offer-list', category: '/cms' },
    { path: '/offer-add', Component: AddOffer, requiredPrivilege: '/offer-add', category: '/cms' },
    { path: '/offer-edit/:id', Component: AddOffer, requiredPrivilege: '/offer-edit/:id', category: '/cms' },
    { path: '/refer-faq', Component: ListReferEarnFAQs, requiredPrivilege: '/refer-faq', category: '/cms' },
    { path: '/referadd', Component: AddReferEarnFAQs, requiredPrivilege: '/referadd', category: '/cms' },
    { path: '/referadd/:id', Component: AddReferEarnFAQs, requiredPrivilege: '/referadd/:id', category: '/cms' },
    { path: '/referral-amount', Component: ReferralAmounts, requiredPrivilege: '/referral-amount', category: '/cms' },
    { path: '/referral-config', Component: ReferralScreenConfig, requiredPrivilege: '/referral-config', category: '/cms' },
    { path: '/cashback-list', Component: CashBackList, requiredPrivilege: '/cashback-list', category: '/cms' },
    { path: '/cashback-add', Component: CashBackAdd, requiredPrivilege: '/cashback-add', category: '/cms' },
    { path: '/cashback-edit/:id', Component: CashBackAdd, requiredPrivilege: '/cashback-edit/:id', category: '/cms' },
    { path: '/recording-retention', Component: RecordingRetention, requiredPrivilege: '/recording-retention', category: '/cms' },
    { path: '/hook-message-config', Component: HookMessageConfig, requiredPrivilege: '/hook-message-config', category: '/cms' },

    // === Manage Content ===
    { path: '/top-banners', Component: TopBanner, requiredPrivilege: '/top-banners', category: '/manage-content' },
    { path: '/promo-banner', Component: PromoBanner, requiredPrivilege: '/promo-banner', category: '/manage-content' },
    { path: '/pooja-category-redirection', Component: PoojaCategoryRedirection, requiredPrivilege: '/pooja-category-redirection', category: '/manage-content' },
    { path: '/onboarding-images', Component: OnboardingImages, requiredPrivilege: '/onboarding-images', category: '/manage-content' },
    { path: '/consultation-type', Component: ConsultationType, requiredPrivilege: '/consultation-type', category: '/manage-content' },
    { path: '/service-banners', Component: ServicesType, requiredPrivilege: '/service-banners', category: '/manage-content' },
    { path: '/about-us', Component: AboutUs, requiredPrivilege: '/about-us', category: '/manage-content' },
    { path: '/privacy-policy', Component: PrivacyPolicy, requiredPrivilege: '/privacy-policy', category: '/manage-content' },
    { path: '/terms-conditions', Component: TermsAndCondition, requiredPrivilege: '/terms-conditions', category: '/manage-content' },
    { path: '/refund-policy', Component: RefundPolicy, requiredPrivilege: '/refund-policy', category: '/manage-content' },
    { path: '/course-specificfaq', Component: FAQList, requiredPrivilege: '/course-specificfaq', category: '/manage-content' },
    { path: '/faq-add', Component: AddFAQ, requiredPrivilege: '/faq-add', category: '/manage-content' },
    { path: '/faq-edit/:id', Component: AddFAQ, requiredPrivilege: '/faq-edit/:id', category: '/manage-content' },
    { path: '/generic-faq', Component: ListGeneric, requiredPrivilege: '/generic-faq', category: '/manage-content' },
    { path: '/generic-add', Component: AddGeneric, requiredPrivilege: '/generic-add', category: '/manage-content' },
    { path: '/faqger-edit/:id', Component: AddGeneric, requiredPrivilege: '/faqger-edit/:id', category: '/manage-content' },
    { path: '/astrology-services', Component: AstrologyServices, requiredPrivilege: '/astrology-services', category: '/manage-content' },
    { path: '/horoscope', Component: Horoscope, requiredPrivilege: '/horoscope', category: '/manage-content' },
    { path: '/trending-consultations', Component: TrendingConsultations, requiredPrivilege: '/trending-consultations', category: '/manage-content' },
    { path: '/advertisement-banner', Component: AdvertisementBanner, requiredPrivilege: '/advertisement-banner', category: '/manage-content' },
    { path: '/video-list', Component: VideoList, requiredPrivilege: '/video-list', category: '/manage-content' },
    { path: '/video-add', Component: VideoAdd, requiredPrivilege: '/video-add', category: '/manage-content' },
    { path: '/video-edit/:id', Component: VideoAdd, requiredPrivilege: '/video-edit/:id', category: '/manage-content' },
    { path: '/recommended-astrologer', Component: RecommendedFreeChat, requiredPrivilege: '/recommended-astrologer', category: '/manage-content' },
    { path: '/free-chat-routing', Component: FreeChatRouting, requiredPrivilege: '/free-chat-routing', category: '/manage-content' },
    { path: '/ticket-subject', Component: TicketSubjectList, requiredPrivilege: '/ticket-subject', category: '/manage-content' },
    { path: '/validate-abusive-words', Component: ValidateAbusiveWords, requiredPrivilege: '/validate-abusive-words', category: '/manage-content' },

    // === Monetization ===
    { path: '/consultation-voucher', Component: ConsultationList, requiredPrivilege: '/consultation-voucher', category: '/monetization' },
    { path: '/consultationvoucher-add', Component: ConsultationAdd, requiredPrivilege: '/consultationvoucher-add', category: '/monetization' },
    { path: '/Concoupons-edit/:id', Component: ConsultationAdd, requiredPrivilege: '/Concoupons-edit/:id', category: '/monetization' },
    { path: '/campaign', Component: CampaignConsultationList, requiredPrivilege: '/campaign', category: '/monetization' },
    { path: '/campaign-add', Component: CampaignConsultationAdd, requiredPrivilege: '/campaign-add', category: '/monetization' },
    { path: '/campaign-edit/:id', Component: CampaignConsultationAdd, requiredPrivilege: '/campaign-edit/:id', category: '/monetization' },
    { path: '/consultation-voucher-tag', Component: WalletTagesList, requiredPrivilege: '/consultation-voucher-tag', category: '/monetization' },
    { path: '/consultation-voucher-tag-add', Component: WalletTagesAdd, requiredPrivilege: '/consultation-voucher-tag-add', category: '/monetization' },
    { path: '/consultation-voucher-tag-edit/:id', Component: WalletTagesAdd, requiredPrivilege: '/consultation-voucher-tag-edit/:id', category: '/monetization' },
    { path: '/consultation-coupon', Component: ListConsultationCoupon, requiredPrivilege: '/consultation-coupon', category: '/monetization' },
    { path: '/consultation-add', Component: AddConsultationCoupon, requiredPrivilege: '/consultation-add', category: '/monetization' },
    { path: '/issue-credit-note', Component: IssueCreditNote, requiredPrivilege: '/issue-credit-note', category: '/monetization' },
    { path: '/coupon-text', Component: CouponText, requiredPrivilege: '/coupon-text', category: '/monetization' },
    { path: '/bucket-management', Component: LoyaltyOfferList, requiredPrivilege: '/bucket-management', category: '/monetization' },
    { path: '/bucket-management-add', Component: AddLoyaltyOffer, requiredPrivilege: '/bucket-management-add', category: '/monetization' },

    // === Reports ===
    { path: '/wallet-balance-report', Component: WalletBalanceReport, requiredPrivilege: '/wallet-balance-report', category: '/reports' },
    { path: '/coupon-usesreport', Component: CouponUsesReport, requiredPrivilege: '/coupon-usesreport', category: '/reports' },
    { path: '/daily-recharge', Component: DailyRechargeReport, requiredPrivilege: '/daily-recharge', category: '/reports' },
    { path: '/invoice-reports', Component: InvoiceReportList, requiredPrivilege: '/invoice-reports', category: '/reports' },
    { path: '/session-reports', Component: SessionReports, requiredPrivilege: '/session-reports', category: '/reports' },
    { path: '/summary-reports', Component: SummaryReports, requiredPrivilege: '/summary-reports', category: '/reports' },
    { path: '/pooja-recommendation-report', Component: PoojaRecommendationReport, requiredPrivilege: '/pooja-recommendation-report', category: '/reports' },
    { path: '/credit-reports', Component: CreditReports, requiredPrivilege: '/credit-reports', category: '/reports' },
    { path: '/payout-reports', Component: PayoutReports, requiredPrivilege: '/payout-reports', category: '/reports' },
    { path: '/payout-reportsView/:id', Component: PayoutReportView, requiredPrivilege: '/payout-reportsView/:id', category: '/reports' },
    { path: '/referral-report', Component: ReferralReport, requiredPrivilege: '/referral-report', category: '/reports' },
    { path: '/astro-earning-history', Component: AstroEarningHistory, requiredPrivilege: '/astro-earning-history', category: '/reports' },
    { path: '/wallet-bonus-report', Component: WalletBonusReport, requiredPrivilege: '/wallet-bonus-report', category: '/reports' },
    { path: '/heat-map', Component: HeatMapBox, requiredPrivilege: '/heat-map', category: '/reports' },
    { path: '/cashback-reports', Component: CashbackReportExport, requiredPrivilege: '/cashback-reports', category: '/reports' },
    { path: '/free-chat-reports', Component: FreeChatReports, requiredPrivilege: '/free-chat-reports', category: '/reports' },
    { path: '/pooja-transaction', Component: PoojaTransactionReport, requiredPrivilege: '/pooja-transaction', category: '/reports' },
    { path: '/pooja-report', Component: PoojaReport, requiredPrivilege: '/pooja-report', category: '/reports' },

    // === Wallet Config ===
    { path: '/wallet-deduction-config', Component: WalletDeductionConfig, requiredPrivilege: '/wallet-deduction-config', category: '/wallet-config' },
    { path: '/bonus-expiry-config', Component: BonusExpiryConfig, requiredPrivilege: '/bonus-expiry-config', category: '/wallet-config' },
    { path: '/pooja-sharing-config', Component: PoojaSharingConfig, requiredPrivilege: '/pooja-sharing-config', category: '/wallet-config' },

    // === Account Management ===
    { path: '/delete-account-button', Component: ShowDeleteAccountButton, requiredPrivilege: '/delete-account-button', category: '/account-management' },
    { path: '/admin-config', Component: AdminConfig, requiredPrivilege: '/admin-config', category: '/account-management' }
];

// =========================================================================
// NO CHANGES BELOW THIS LINE IN THIS FILE
// =========================================================================
const getUserPrivileges = () => {
    const userData = JSON.parse(localStorage.getItem("astroVani-admin-data") || "{}");

    if (!userData || !userData.role) {
        return [];
    }
    const roleData = userData.role;

    if (typeof roleData === 'object' && roleData !== null && Array.isArray(roleData.privileges)) {
        if (roleData.privileges.includes('*')) {
            return ['SUPER_ADMIN'];
        }
        return roleData.privileges;
    }

    if (typeof roleData === 'string') {
        const upperCaseRole = roleData.toUpperCase();
        if (upperCaseRole === 'SUPER_ADMIN' || upperCaseRole === 'ADMIN') {
            return ['SUPER_ADMIN'];
        }
    }

    return [];
};

const PrivateRoute = ({ children, requiredPrivilege, userPrivileges }) => {
    const isSuperAdmin = userPrivileges.includes('SUPER_ADMIN');

    const hasPermission = userPrivileges.some(p => {
        if (p.includes(':')) {
            const basePrivilege = p.split('/:')[0];
            const baseRequired = requiredPrivilege.split('/:')[0];
            return basePrivilege === baseRequired;
        }
        return p === requiredPrivilege;
    });

    if (isSuperAdmin || hasPermission) {
        return children;
    }

    return <Navigate to={process.env.PUBLIC_URL + "/unauthorized"} />;
};

const Unauthorized = () => (
    <div className='d-flex justify-content-center align-items-center' style={{ height: '60vh' }}>
        <div className='text-center'>
            <h2 className='text-danger'>403 - Access Denied</h2>
            <p className='text-muted'>You do not have the required permissions to view this page.</p>
        </div>
    </div>
);

const LoadingScreen = () => (
    <div className='d-flex justify-content-center align-items-center vh-100'>
        <h2>Loading...</h2>
    </div>
);

function MainIndex(props) {
    const { activekey } = props;
    const [privileges, setPrivileges] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const userPrivs = getUserPrivileges();
        setPrivileges(userPrivs);
        setIsLoading(false);
    }, []);

    if (isLoading) {
        return <LoadingScreen />;
    }

    const userToken = localStorage.getItem("astroVani-admin-token");
    if (!userToken) {
        return <Navigate to={process.env.PUBLIC_URL + "/sign-in"} />;
    }

    const isSuperAdmin = privileges.includes('SUPER_ADMIN');

    return (
        <div className='main px-lg-4 px-md-4'>
            {activekey === "/chat" ? "" : <Header />}
            {activekey === "/chat" ? "" : (
                <div className="pt-3">
                    <PoojaCounts />
                </div>
            )}
            <div className="body d-flex py-3">
                <ReactRoutes>
                    <Route path={process.env.PUBLIC_URL + "/"} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />} />
                    <Route path={process.env.PUBLIC_URL + "/unauthorized"} element={<Unauthorized />} />

                    {allRoutes.map(({ path, Component, requiredPrivilege }) => (
                        <Route
                            key={path}
                            path={process.env.PUBLIC_URL + path}
                            element={
                                <PrivateRoute userPrivileges={privileges} requiredPrivilege={requiredPrivilege}>
                                    <Component />
                                </PrivateRoute>
                            }
                        />
                    ))}

                    <Route
                        path="*"
                        element={
                            isSuperAdmin
                                ? <Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />
                                : <Unauthorized />
                        }
                    />
                </ReactRoutes>
                <ScrollToTop />
            </div>
        </div>
    );
}

export default MainIndex;